module.exports = __webpack_public_path__ + "img/AT0000001268026.7d4125d2.png";